import { isServer } from '@/utils/isServer';

export const reloadPageWithParams = (params: Record<string, string | number | boolean | undefined>) => {
  if (isServer()) return;

  const currentQuery = new URLSearchParams(window.location.search);

  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined) {
      currentQuery.delete(key);
    } else {
      currentQuery.set(key, String(value));
    }
  });

  const newUrl = `${window.location.pathname}?${currentQuery.toString()}`;

  window.location.href = newUrl;
};
